import { useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Loader2 } from "lucide-react";
import { useApi } from "@/lib/api";

export const RelatedAyat = ({ item, index }) => {
  const api = useApi();
  const [data, setData] = useState(null);
  const load = async (open) => {
    if (!open || data) return;
    try { setData(await api("get", "/quran/ayat", null, { params: { surah: item.surah, from: item.from, to: item.to } })); }
    catch { setData({ error: true }); }
  };
  return (
    <li>
      <Popover onOpenChange={load}>
        <PopoverTrigger asChild>
          <button className="text-left w-full rounded-xl p-3 border border-line hover:border-[var(--q)] transition-colors" data-testid={`related-ayat-${index}`}>
            <span className="font-mono-data text-xs text-q">{item.rujukan}</span>
            {item.kaitan && <span className="block text-sm text-ink/90 mt-1 leading-relaxed">{item.kaitan}</span>}
          </button>
        </PopoverTrigger>
        <PopoverContent className="w-[min(92vw,460px)] max-h-[60vh] overflow-y-auto" data-testid={`related-ayat-popover-${index}`}>
          {!data ? <Loader2 className="animate-spin text-q" size={18} /> : data.error ? <p className="text-sm">Gagal memuat ayat.</p> : (
            <div className="space-y-3">
              <div className="font-mono-data text-xs text-q">{data.rujukan}</div>
              <p className="arabic !text-[24px]" lang="ar" dir="rtl">{data.arab}</p>
              <p className="text-sm leading-relaxed">{data.terjemahan}</p>
            </div>
          )}
        </PopoverContent>
      </Popover>
    </li>
  );
};
